/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LicenseRead } from './LicenseRead';
import {
    LicenseReadFromJSON,
    LicenseReadFromJSONTyped,
    LicenseReadToJSON,
    LicenseReadToJSONTyped,
} from './LicenseRead';

/**
 * Paginated response for the superadmin license list.
 * @export
 * @interface PaginatedLicensesResponse
 */
export interface PaginatedLicensesResponse {
    /**
     * Licenses on this page
     * @type {Array<LicenseRead>}
     * @memberof PaginatedLicensesResponse
     */
    items: Array<LicenseRead>;
    /**
     * Total number of matching licenses
     * @type {number}
     * @memberof PaginatedLicensesResponse
     */
    total: number;
    /**
     * Number of records skipped
     * @type {number}
     * @memberof PaginatedLicensesResponse
     */
    skip: number;
    /**
     * Maximum number of records returned
     * @type {number}
     * @memberof PaginatedLicensesResponse
     */
    limit: number;
}

/**
 * Check if a given object implements the PaginatedLicensesResponse interface.
 */
export function instanceOfPaginatedLicensesResponse(value: object): value is PaginatedLicensesResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('skip' in value) || value['skip'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    return true;
}

export function PaginatedLicensesResponseFromJSON(json: any): PaginatedLicensesResponse {
    return PaginatedLicensesResponseFromJSONTyped(json, false);
}

export function PaginatedLicensesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedLicensesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(LicenseReadFromJSON)),
        'total': json['total'],
        'skip': json['skip'],
        'limit': json['limit'],
    };
}

export function PaginatedLicensesResponseToJSON(json: any): PaginatedLicensesResponse {
    return PaginatedLicensesResponseToJSONTyped(json, false);
}

export function PaginatedLicensesResponseToJSONTyped(value?: PaginatedLicensesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(LicenseReadToJSON)),
        'total': value['total'],
        'skip': value['skip'],
        'limit': value['limit'],
    };
}

